/*** old one start*/
import {
  dateChangerFunc,
  getCurrentDate,
  getCurrentDateWithOutHyphen,
} from "../../../helpers/dateParser";
import amarnathImageNew from "../../../assets/images/amarnath-logo-new.jpeg";

export const newGstReport = (orderProducts, personalDetails) => {
  console.log("order products", orderProducts);

  const invoiceNumber = `INV-${getCurrentDateWithOutHyphen()}-${
    orderProducts[0].order_id
  }`;

  const customerName = orderProducts[0].customer_name;
  const customerAddress = orderProducts[0].address;
  const customerPlace = orderProducts[0].place;
  const customerGSTDetails = orderProducts[0].gst_details;
  const panDetails = orderProducts[0].pan_details;
  const logo = personalDetails.logo;
  const partialAmount = orderProducts[0].partial_amount;

  const goldRate = orderProducts[0].gold_rate;
  const silverRate = orderProducts[0].silver_rate;
  const modeOfPayment = orderProducts[0].mode_of_payment;
  const isHallMarkAvaliable =
    orderProducts[0].hall_mark_charge !== null &&
    orderProducts[0].hall_mark_charge != 0.0 &&
    orderProducts[0].hall_mark_charge !== "";
  const hsnServiceCharge = orderProducts[0].hall_mark_charge / 1.18 || 0;
  const hsnServiceCharge_With_GST = (18 / 100) * hsnServiceCharge || 0;

  const calculteAddedVal = (order) => {
    let amount = parseFloat(order.amount);
    let quantity = order.quantity;
    let mc = parseFloat(order.mc);
    let goldPrice = parseFloat(goldRate);
    let silverPrice = parseFloat(silverRate);
    let gram = parseFloat(order.gram);

    let basePrice = amount / 1.03;

    let gst_3_percent = amount - basePrice;

    let actual_prodrate_quan_gram = 0;

    if (order.product_name === "Gold") {
      actual_prodrate_quan_gram = gram * quantity * goldPrice;
    }
    if (order.product_name === "Silver") {
      actual_prodrate_quan_gram = gram * quantity * silverPrice;
    }

    let tot = gst_3_percent + actual_prodrate_quan_gram + mc;

    let VAT_Amt = amount - tot;

    let v_added = 0;
    if (order.product_name === "Gold") {
      v_added = VAT_Amt / goldRate;
    }
    if (order.product_name === "Silver") {
      v_added = VAT_Amt / silverRate;
    }

    return v_added.toFixed(3);
  };

  let totalGrossAmount = 0;

  // const calculateGrossAmount = (item) => {
  //   const amount = parseFloat(item.amount);
  //   const gstPercent = parseFloat(item.gst_percent);
  //   const gstAmount = (amount * gstPercent) / 100;
  //   const grossAmount = amount - gstAmount;
  //   totalGrossAmount += grossAmount; // Add gross amount to totalGrossAmount
  //   return grossAmount.toFixed(2); // Return gross amount rounded to 2 decimal places
  // };

  const calculateGrossAmount = (item) => {
    const amount = parseFloat(item.amount);
    const gstPercent = parseFloat(item.gst_percent);
    const grossAmount = amount / (1 + gstPercent / 100); // Calculate gross amount as amount / (1 + GST%)
    totalGrossAmount += grossAmount; // Add gross amount to totalGrossAmount
    return grossAmount.toFixed(2); // Return gross amount rounded to 2 decimal places
  };

  let totalAmount = 0;
  orderProducts.map((item) => (totalAmount += parseFloat(item.amount)));

  let totalGrams = 0;
  orderProducts.map((item) => (totalGrams += parseFloat(item.gram || 0)));

  let total_GST_Amount = orderProducts.map(
    (item) => (parseFloat(item.gst_percent) / 100) * parseFloat(item.amount)
  );

  // Extract unique HSN codes
  const uniqueHsnCodes = [
    ...new Set(orderProducts.map((item) => item.hsn_code)),
  ];

  // Calculate taxable values and tax amounts for each unique HSN code
  const hsnDetails = uniqueHsnCodes.map((hsnCode) => {
    const itemsWithHsn = orderProducts.filter(
      (item) => item.hsn_code === hsnCode
    );

    // const taxableValue = itemsWithHsn.reduce(
    //   (sum, item) => sum + parseFloat(item.amount),
    //   0
    // );

    const taxableValue = itemsWithHsn.reduce(
      (sum, item) =>
        sum +
        parseFloat(item.amount) / (1 + parseFloat(item.gst_percent) / 100),
      0
    ); // Taxable value is gross amount (amount / (1 + GST%))

    const gstPercent = itemsWithHsn[0].gst_percent; // Assuming all items with the same HSN code have the same GST percent
    const cgstAmount = (taxableValue * (gstPercent / 100)) / 2;
    const sgstAmount = (taxableValue * (gstPercent / 100)) / 2;
    const totalTax = cgstAmount + sgstAmount;

    return {
      hsnCode,
      taxableValue,
      gstPercent,
      cgstAmount,
      sgstAmount,
      totalTax,
    };
  });

  let totalGSTAmount = 0;
  hsnDetails.map((item) => (totalGSTAmount += item.totalTax));

  const calculateNetTotal = (gross_hsn_service, gst_s, gst_c, hsn_s, hsn_c) => {
    return (gross_hsn_service + gst_s + gst_c + hsn_s + hsn_c).toFixed(2);
  };

  // Create a new window for printing
  const printWindow = window.open("", "GST Billing");

  // Define the maximum number of rows per page
  const maxRowsPerPage = 15; // Adjust this value as needed

  const hsnTableRows = 2;

  // Calculate the number of empty rows needed
  const dataRows = orderProducts.length;
  const emptyRowsNeeded = Math.max(0, maxRowsPerPage - dataRows - hsnTableRows);

  const getHUIDs = (data) => {
    if (data.product_name === "Silver") {
      return "";
    }
    if (data.huid === null) {
      let huids = [];
      let parsedPairs = JSON.parse(JSON.parse(data.pairs));
      parsedPairs.map((pair) => {
        huids.push(pair.huid);
      });
      return huids.join(", ");
    } else {
      return data.huid || "N/A";
    }
  };

  // Preload the logo image
  const preloadImage = new Image();
  preloadImage.src = logo;

  // Generate the content
  printWindow.document.write(`
    <!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Invoice</title>
  <link rel="stylesheet" href="./styles.css" />
  <style>
    body {
      font-family: Arial, sans-serif;
      padding: 0px;
      font-size: 9px; /* Default font size for other elements */
    }

    .invoice-container {
      width: 95%;
      margin: auto;
      border: 1px solid #424242;
      padding: 5px;
    }

    .header {
      display: flex; /* Use flexbox for alignment */
      align-items: center; /* Center items vertically */
      justify-content: space-between; /* Space between logo and title */
      margin-bottom: 10px;
      line-height: 5px;
      font-size: 10px; /* Font size for headers */
    }

    .header img {
      height: 70px; /* Adjust logo height */
      width: 50px; /* Adjust logo width */
    }

    .header-title {
      text-align: center; /* Center the title */
      flex-grow: 1; /* Allow title to take available space */
    }

    .left-align {
      text-align: left;
    }

    .seller-details {
      text-align: center;
      margin-bottom: 10px;
      font-size: 10px; /* Header-style font size */
    }

    .invoice-details {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 2px;
      line-height: 7px;
    }
    .small-width {
      width: 8%;
    }
    .medium-width {
      width: 20%;
    }
    .fw-bold {
      font-weight: bold;
    }
    .left {
      text-align: left;
    }

    .right {
      text-align: right;
    }

    #textRight{
      text-align: right;
      }

    .left,
    .right {
      width: 50%;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 10px;
    }

    th,
    td {
      border: 0.2px solid #d9d4d4;
      padding: 5px;
      text-align: center;
    }

    .total {
      text-align: right;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .declaration-bank {
      font-size: 7px;
      display: flex;
      justify-content: space-between;
      line-height: 12px;
    }

    .signature {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0px;
    }
    .auth-sign {
      width: 30%;
    }
    .irn-ack {
      line-height: 10px;
    }
    .bank-details {
      margin-top: -10px;
      width: 20%;
      line-height: 5px;

    }

    .declaration {
      margin-top: -8px;

      width: 45%;
    }

    .payment {
      margin-top: -10px;
      margin-bottom: 10px;
    }
    .second-table {
      margin-top: -10px;
    }

    .footer {
      margin-top: -10px;
      text-align: center;
      font-size: 9px;
    }
  </style>
</head>
<body>
  <div class="invoice-container">
    <!-- Header Section -->
    <div class="header">
      <img id="logoImage" src=${logo || amarnathImageNew} alt="Company Logo" />
      <div class="header-title">
        <h3 style="color:red;">SHIVA AMARNATH JEWELLERS</h3>
        <p>449, Annal Gandhiadikal Salai, Vandikarastreet</p>
        <p>Ramanathapuram-623501</p>
        <p>Phone: 9994522709</p>
        <p><u>Tax Invoice</u></p>
      </div>
    </div>

    <!-- Invoice Details -->
    <div class="invoice-details">
      <div class="left">
        <p><strong>Customer Details:</strong></p>
        <p><strong>${customerName}</strong></p>
        <p>${customerAddress}, ${customerPlace}</p>
        ${
          customerGSTDetails &&
          `<p><strong>GSTIN: ${customerGSTDetails}</strong></p>`
        }
        ${panDetails && `<p><strong>PAN Details: ${panDetails}</strong></p>`}
      </div>
      <div class="right">
        <p><strong>Invoice No:</strong>${invoiceNumber}</p>
        <p><strong>Date:</strong>${dateChangerFunc(getCurrentDate())}</p>
        <p><strong>Gold Rate:</strong> ${goldRate}</p>
        <p><strong>Silver Rate:</strong> ${silverRate}</p>
        <p><strong>GSTIN:</strong>33AEZPV3845D1ZZ</p>
      </div>
    </div>

    <!-- Item Table -->
    <table>
      <thead>
        <tr>
          <th class="small-width">S No.</th>
          <th class="medium-width">Description</th>
          <th class="small-width">HUID</th>
          <th class="small-width">HSN Code</th>
          <th class="small-width">Grams</th>
          <th class="small-width">Quantity</th>
          <th class="small-width">V.Added</th>
          <th class="small-width">MC</th>
          <th class="medium-width">Gross Amount</th>
          <th class="medium-width">Amount</th>
        </tr>
      </thead>
      <tbody>
        ${orderProducts
          .map(
            (item, index) => `
              <tr>
                <td>${index + 1}</td>
                <td>${item.product_type_name + "-" + item.model_name}</td>
                <td>${getHUIDs(item)}</td>
                <td>${item.hsn_code || "N/A"}</td>
                <td>${item.gram || "0"}</td>
                <td>${item.quantity || "0"}</td>
                <td>${calculteAddedVal(item) || "0"}</td>
                <td>${item.mc || "0"}</td>
                <td>${calculateGrossAmount(item)}</td>
                <td>${item.amount || "0.00"}</td>
              </tr>
            `
          )
          .join("")}
          ${
            isHallMarkAvaliable
              ? `
                <tr>
                  <td></td>
                  <td>HSN Service</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>${hsnServiceCharge.toFixed(2)}</td>
                  <td>${orderProducts[0].hall_mark_charge}</td>
                </tr>
              `
              : ""
          }

          <!-- Add empty rows dynamically -->
          ${
            orderProducts.length > 0
              ? Array(emptyRowsNeeded)
                  .fill()
                  .map(
                    () => `
                      <tr><td colspan="10">&nbsp;</td></tr>
                    `
                  )
                  .join("")
              : ""
          }

          <!-- New Total Row -->
          <tr>
            <td colspan="3"><strong>Total Gram</strong></td>
            <td></td>
            <td><strong>${totalGrams}</strong></td>
            <td></td>
            <td></td>
            <td></td>
            <td><strong>New Total</strong></td>
            <td><strong>${(totalGrossAmount + hsnServiceCharge).toFixed(
              2
            )}</strong></td>
          </tr>
          <tr>
          <td></td>
            <td id="textRight" colspan="8"><strong>SGST</strong></td>
            <td>${(totalGSTAmount / 2).toFixed(2)}</td>
          </tr>
          <tr>
           <td></td>
            <td id="textRight" colspan="8"><strong>CGST</strong></td>
            <td>${(totalGSTAmount / 2).toFixed(2)}</td>
            
          </tr>
          ${
            isHallMarkAvaliable
              ? `
                <tr>
                  <td colspan="8" id="textRight">
                    <strong>SGST(HSN Service - 9%)</strong>
                  </td>
                  <td>${(hsnServiceCharge_With_GST / 2).toFixed(2)}</td>
                  <td></td>
                </tr>
                <tr>
                  <td id="textRight" colspan="8">
                    <strong>CGST(HSN Service - 9%)</strong>
                  </td>
                  <td>${(hsnServiceCharge_With_GST / 2).toFixed(2)}</td>
                  <td></td>
                </tr>
              `
              : ""
          }
          <tr>
           <td></td>
            <td id="textRight" colspan="8"><strong>TDS</strong></td>
            <td>0</td>
            
          </tr>
          <tr>
           <td></td>
            <td id="textRight" colspan="8"><strong>Round Off</strong></td>
            <td>0</td>
           
          </tr>
          <tr>
            <td colspan="5"></td>
            <td></td>
            <td></td>
             <td></td>
            <td><strong>Net Total</strong></td>
            <td><strong>${calculateNetTotal(
              totalGrossAmount + hsnServiceCharge,
              totalGSTAmount / 2,
              totalGSTAmount / 2,
              hsnServiceCharge_With_GST / 2,
              hsnServiceCharge_With_GST / 2
            )}</strong></td>
           
          </tr>
           ${
             partialAmount
               ? `<tr>
            <td colspan="5"></td>
            <td></td>
            <td></td>
             <td></td>
            <td><strong>Balance Amount To Be Paid</strong></td>
            <td><strong>${
              calculateNetTotal(
                totalGrossAmount + hsnServiceCharge,
                totalGSTAmount / 2,
                totalGSTAmount / 2,
                hsnServiceCharge_With_GST / 2,
                hsnServiceCharge_With_GST / 2
              ) - partialAmount
            }</strong></td>
          </tr>`
               : ""
           }
        </tbody>
      </table>
      <table class="second-table">
        <thead>
          <tr>
            <th rowspan="2">HSN/SAC</th>
            <th rowspan="2">Taxable Value</th>
            <th colspan="2" rowspan="1">Central Tax</th>
            <th colspan="2" rowspan="1">State Tax</th>
            <th rowspan="2">Total Tax</th>
          </tr>
          <tr>
            <th>Rate</th>
            <th>Amount</th>
            <th>Rate</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody class="fw-bold">
          ${hsnDetails
            .map(
              (hsnDetail) => `
                <tr>
                  <td>${hsnDetail.hsnCode}</td>
                  <td>${hsnDetail.taxableValue.toFixed(2)}</td>
                  <td>${hsnDetail.gstPercent / 2}%</td>
                  <td>${hsnDetail.cgstAmount.toFixed(2)}</td>
                  <td>${hsnDetail.gstPercent / 2}%</td>
                  <td>${hsnDetail.sgstAmount.toFixed(2)}</td>
                  <td>${hsnDetail.totalTax.toFixed(2)}</td>
                </tr>
              `
            )
            .join("")}
        </tbody>
      </table>

      <!-- Declaration and Bank Details -->
      <div class="declaration-bank">
        <div class="declaration">
          <p><strong>Declaration:</strong></p>
          <p>
            We declare that this invoice shows the actual price of the goods
            described and that all particulars are true and correct.
          </p>
          <p><strong>Remarks:</strong> Including VA and Hallmark charges.</p>
        </div>
        <div class="bank-details">
          <p><strong>Company's Bank Details:</strong></p>
          <p><strong>Bank:</strong>${personalDetails.bank}</p>
          <p><strong>Account No:</strong>${personalDetails.acc_no}</p>
          <p><strong>IFSC Code:</strong>${personalDetails.ifsc_code}</p>
          <p><strong>Branch:</strong>${personalDetails.branch}</p>
        </div>
      </div>

      <!-- Payment Details -->
      <div class="payment">
        <p><strong>Terms of Payment:</strong></p>
         <p>${modeOfPayment || "Not Available"}</p> 
        ${partialAmount ? `<p>Partial Amount : ${partialAmount}</p>` : ""}
      </div>
      <br><br>

      <div class="signature">
        <div class="cus-sign">
          <p>Customer Signature</p>
        </div>
        <div class="auth-sign">
          <p>Authorised Signature</p>
        </div>
      </div>

      <!-- Footer -->
      <div class="footer">
        <p><strong>SUBJECT TO RAMANATHAPURAM JURISDICTION</strong></p>
        <p>This is a Computer Generated Invoice</p>
      </div>
    </div>

   <script>
   console.log('Script running in print window');
    const logoImage = document.getElementById('logoImage');

    function triggerPrint() {
      // Delay printing by 3 seconds
      setTimeout(() => {
        window.print();
      }, 3000); // 3000ms = 3 seconds
    }

    // Check if the image is already loaded (e.g., cached)
    if (logoImage.complete && logoImage.naturalWidth !== 0) {
      console.log('Image already loaded');
      triggerPrint();
    } else {
      console.log('Image loading...');
      logoImage.onload = function() {
        console.log('Image loaded successfully');
        triggerPrint();
      };
      logoImage.onerror = function() {
        console.error('Image failed to load:', '${logo}');
        triggerPrint(); // Print anyway if the image fails
      };
    }
  </script>
  </body>
</html>
  `);

  printWindow.document.close();

  // Optionally, trigger print if needed
  printWindow.print();
};
